import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredPermission = route.data['requiredPermission'];

    if (!requiredPermission) {
      return of(true); 
    }

    // Pedimos los permisos frescos y usamos la inteligencia centralizada de hasPermission
    return this.authService.loadMyPermissions().pipe(
      map(() => {
        if (this.authService.hasPermission(requiredPermission)) {
          return true; // ¡Adelante!
        } else {
          // No tiene acceso, lo mandamos al Home
          return this.router.createUrlTree(['/app/home']); 
        }
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['/login']));
      })
    );
  }
}